import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DateTime } from 'luxon';
import { TaskStatus } from '@cf-shared/data-model/day-task-status-cache';
import { CsRollerListInterface } from 'components/cs-roller/cs-roller-list-interface';
import { CsSliderTickmark } from 'components/cs-slider/cs-slider';

// The Pickers card's body on the Test UI Components page (#6020): slider, roller, day buttons, date
// range toolbar, the calorie change input (#5456), task calendar, skinfold site measure and the read-only radio row.
@Component({
  selector: 'cs-test-pickers-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-pickers-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestPickersCardComponent {
  readonly TaskStatus = TaskStatus;

  sliderValue = 40;
  readonly sliderTickmarks: CsSliderTickmark[] = [{ value: 0, label: '0' }, { value: 50, label: '50' }, { value: 100, label: '100' }];
  readonly rollerData: CsRollerListInterface = {
    getTotalElements: () => 20,
    getElement: (index: number) => `${(index + 1) * 5} kg`,
  };
  rollerIndex = 7;
  trainingDays = [true, false, true, false, true, false, false];
  readonly calendarStatuses = new Map<string, TaskStatus>([
    [DateTime.local().minus({ days: 2 }).toISODate(), TaskStatus.Completed],
    [DateTime.local().minus({ days: 1 }).toISODate(), TaskStatus.Incomplete],
    [DateTime.local().toISODate(), TaskStatus.InProgress],
  ]);
  calendarSelectedDay = DateTime.local();
  readonly today = DateTime.local();
  skinfoldMeasures = [12, 13];
  // cs-calorie-change-input: BORI reported 2,178 kcal and the app recommends 2,069, a decrease of 5%
  calorieTarget: number | undefined = 2069;
  /** the row picked inside the cs-next-intake-card example */
  nextIntakePick: string | undefined;
}
